/**
 * Created by lbridges on 2/10/15.
 */
define(['jquery', 'bing', 'c21/maps', 'c21/ajax'], function ($, BingMaps, C21Maps, ajax) {
   "use strict";
   var self = {},
      mMap = null;
   function initializeMap() {
      var jHolder = $('#communityAreaMap'),
         location;

      if (mMap !== null && !jHolder.hasClass('hasMap')) {
         mMap = null;
      }
      if (mMap === null && jHolder.is(":visible")) {
         jHolder.addClass('hasMap');
         location = new BingMaps.Location(jHolder.data("lat"), jHolder.data("lon"));

         mMap = new BingMaps.Map(jHolder.get(0), {
            credentials: C21Maps.bingmapCredentials,
            center: location,
            showDashboard: false,
            zoom: 13,
            mapTypeId: BingMaps.MapTypeId.auto,
            customizeOverlays: true,
            enableSearchLogo: false,
            disableUserInput: true
         });
         mMap.entities.push(new BingMaps.Pushpin(location));
      }
   }
   self.initialize = function() {
      initializeMap();
   };
   return self;
});
